import React, { useRef, useState, useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { FaChartBar, FaChartLine, FaDownload } from "react-icons/fa";
import { RiResetLeftLine } from "react-icons/ri";
import { GoNumber } from "react-icons/go";

const monthKeys = [
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
  "JAN",
  "FEB",
  "MAR",
];

const MachineEngSecWiseGraph = ({
  data,
  title = "",
  singleValue = false,
  setActive,
  active,
}) => {
  const chartRef = useRef(null);
  const [chartType, setChartType] = useState("bar");
  const [showValues, setShowValues] = useState(false);
  const head = ["Demand", "Agreed"];

  const years = useMemo(() => {
    return [...new Set(data.map((d) => d.year))].sort();
  }, [data]);

  const [selectedYear, setSelectedYear] = useState(years[years.length - 1]);

  const filteredData = useMemo(() => {
    return data.filter((d) => d.year === selectedYear);
  }, [data, selectedYear]);

  if (!filteredData.length) return null;

  const sections = filteredData.map((d) => d.section);

  const series = monthKeys.map((month) => ({
    name: month,
    type: chartType === "line" ? "line" : "bar",
    stack: chartType === "line" ? undefined : "total",
    smooth: chartType === "line",
    barWidth: "60%",
    emphasis: { focus: "series" },
    data: filteredData.map((row) => ({
      value: Number(row[month]) || 0,
      label: {
        show: showValues,
        position: "inside",
        formatter: (params) => (showValues ? params.value : ""),
        fontSize: 9,
      },
    })),
  }));

  const option = {
    title: {
      left: "center",
      text: `${title} `,
      textStyle: { fontSize: 16, fontWeight: "600" },
    },
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: { top: 10, type: "scroll" },
    grid: {
      top: "20%",
      left: "5%",
      right: "5%",
      bottom: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: sections,
      axisLabel: { rotate: 40 },
    },
    yAxis: {
      type: "value",
      name: active === "Agreed" ? "No. of Agreed" : " No. of Demand",
    },
    series,
  };

  const downloadChart = () => {
    const chart = chartRef.current.getEchartsInstance();
    const img = chart.getDataURL({
      type: "png",
      pixelRatio: 2,
      backgroundColor: "#fff",
    });
    const a = document.createElement("a");
    a.href = img;
    a.download = `${title}_${selectedYear}.png`;
    a.click();
  };

  const resetChart = () => {
    setChartType("bar");
    setShowValues(false);
  };

  return (
    <div className="border p-3">
      <h5 className="bg-dark p-2 text-white d-flex justify-content-between">
        Section Wise Graph
        <select
          className="small"
          value={active}
          onChange={(e) => setActive(e.target.value)}
        >
          {head.map((type) => (
            <option key={type} value={type}>
              {type.replace("_", " ")}
            </option>
          ))}
        </select>
      </h5>

      <div className="d-flex justify-content-center mb-2 mt-2">
        {years.map((yr) => (
          <button
            key={yr}
            className={`btn btn-sm me-2 ${
              selectedYear === yr ? "btn-dark" : "btn-outline-dark"
            }`}
            onClick={() => setSelectedYear(yr)}
          >
            {yr}
          </button>
        ))}
      </div>

      {!singleValue && (
        <div className="d-flex justify-content-end mt-1">
          <button
            className="btn btn-sm btn-outline-dark me-1"
            onClick={() => setShowValues((prev) => !prev)}
            style={{ height: "25px" }}
          >
            <GoNumber /> Values
          </button>

          <button
            className="btn btn-sm btn-outline-dark me-1"
            onClick={downloadChart}
            style={{ height: "25px" }}
          >
            <FaDownload />
          </button>

          <button
            className={`btn btn-sm btn-outline-dark me-1 ${
              chartType === "bar" ? "active" : ""
            }`}
            onClick={() => setChartType("bar")}
            style={{ height: "25px" }}
          >
            <FaChartBar />
          </button>

          <button
            className={`btn btn-sm btn-outline-dark me-1 ${
              chartType === "line" ? "active" : ""
            }`}
            onClick={() => setChartType("line")}
            style={{ height: "25px" }}
          >
            <FaChartLine />
          </button>

          <button
            className="btn btn-sm btn-outline-dark me-1"
            onClick={resetChart}
            style={{ height: "25px" }}
          >
            <RiResetLeftLine />
          </button>
        </div>
      )}

      <ReactECharts
        ref={chartRef}
        option={option}
        notMerge
        style={{ height: singleValue ? "250px" : "400px", width: "100%" }}
      />
    </div>
  );
};

export default MachineEngSecWiseGraph;
